<app-modal-form [buttonTitle]="'Connexion'" [modalTitle]="'Reconnexion requise'"
  [isEditMode]="isEditMode" [showClose]="false" [isSaving]="isSaving" (dismissModal)="dismiss()"
  (toggleEditMode)="submitForm()" (submitForm)="submitForm()">
    <p>La tentative de reconnexion a échoué. Votre session a expiré. Veuillez vous reconnecter.</p>
    
    <form [formGroup]="authForm">
      <fieldset [disabled]="isSaving">
        
        <div class="mb-3">
          <label for="email">Adresse e-mail</label>
          <input formControlName="email" class="form-control" placeholder="Adresse e-mail" type="text" />

          <div *ngIf="submitted && f.email && f.email.errors" class="invalid-feedback">
            <div *ngIf="f.email.errors.required">L'email est requis</div>
            <div *ngIf="f.email.errors.email">L'email doit être une adresse email valide</div>
          </div>
        </div>
    
    
        <div class="mb-3">
          <label for="email">Mot de passe</label>
          <input formControlName="password"  class="form-control" placeholder="*******" type="password" />
          <div *ngIf="submitted && f.password && f.password.errors" class="invalid-feedback">
            <div *ngIf="f.password.errors.required">Mot de passe requis</div>
          </div>
        </div>
    
        <div class="text-right forgetpassbloc mt-3">
          <a class="text-primary cursor-hand" (click)="forgotPassword()">Mot de passe oublié ?</a>
        </div>
      </fieldset>
    </form>
</app-modal-form>